import type { TranslatesReplacements } from '@powerplay/core-minigames'

/**
 * Vymeny textov pre preklady - prekonkretnu disciplinu
 */
export const translatesReplacements: TranslatesReplacements[] = [

  {
    text: 'instructionsDiscipline6Cell4Text1',
    replace: [
      {
        original: '[2to4]',
        new: '2'
      }
    ]
  },
  {
    text: 'instructionsDisciplineTraining6Cell3Text1',
    replace: [
      {
        original: '[number]',
        new: '20'
      }
    ]
  },
  {
    text: 'tutorialTask6-2',
    replace: [
      {
        original: '[number]',
        new: '15'
      }
    ]
  },
  {
    text: 'tutorialText6-3',
    replace: [
      {
        original: '[number]',
        new: '15'
      }
    ]
  },

]
